export const navigationConstants = {
  DASHBOARD: "/dashboard",
  LOGIN: "/login",
  UNAUTHORISE: "/unauthorise", 
};
